import React from 'react';
import { connect } from 'react-redux';
import { getActiveDocumentCount } from 'src/services/newdashboard';
import DocumentBlockPres from '../Presentation/DocumentBlockPres';

class DocumentBlockContainer extends React.Component {
  state = { activeDocumentCount: null };
  componentDidMount() {
    if (this.props.caseId) {
      this.setState({ activeDocumentCount: null });
      getActiveDocumentCount(this.props.caseId).then(response => {
        this.setState({ activeDocumentCount: response });
      });
    }
  }
  componentWillUnmount() {}
  render() {
    return (
      <DocumentBlockPres caseId={this.props.caseId} activeDocumentCount={this.state.activeDocumentCount} history={this.props.history} />
    );
  }
}
const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(DocumentBlockContainer);
